module.exports = __webpack_public_path__ + "media/Audio15_p.fc662ffc.wav";